import { render, staticRenderFns } from "./ResearchInformation.vue?vue&type=template&id=e97fc33e&scoped=true"
import script from "./ResearchInformation.vue?vue&type=script&lang=js"
export * from "./ResearchInformation.vue?vue&type=script&lang=js"
import style0 from "./ResearchInformation.vue?vue&type=style&index=0&id=e97fc33e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97fc33e",
  null
  
)

export default component.exports